module.exports = __webpack_public_path__ + "img/1 (61).a15d259c.png";